import React from 'react';
import './ProductTutorials.scss';

import classnames from 'classnames';
import { LVL_ADVANCED, LVL_BEGINNER, LVL_INTERMEDIATE } from '../../utils/constants';

interface ProductTutorialsProps {
  type: string;
  data: any;
}

export default function ProductTutorial({ type, data }: ProductTutorialsProps): React.ReactElement {
  return (
    <section className="software__tutorials">
      {data &&
        data.map((softwareCategory) => {
          if (softwareCategory.firstLevelCategory !== type) return null;
          return softwareCategory.nestedCategories.map((release) => {
            return release.nestedChildren.map((el) => {
              return (
                <a key={el.url} className="software__tutorial" href={el.url}>
                  <span
                    className={classnames('software__tutorial--label', {
                      'software__tutorial--label-beginner': el.difficulty === LVL_BEGINNER,
                      'software__tutorial--label-intermediate': el.difficulty === LVL_INTERMEDIATE,
                      'software__tutorial--label-advanced': el.difficulty === LVL_ADVANCED,
                    })}
                  >
                    {el.difficulty}
                  </span>
                  <h4>{el.title}</h4>
                  <p>{el.description}</p>
                </a>
              );
            });
          });
        })}
    </section>
  );
}
